import { render, staticRenderFns } from "./langImport.vue?vue&type=template&id=10b51f10&scoped=true&"
import script from "./langImport.vue?vue&type=script&lang=js&"
export * from "./langImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b51f10",
  null
  
)

export default component.exports